/* LZ BN Rani popust funnel — 3 koraka (šta ti treba → kategorija → veličina), svaki otključava poklon,
   na kraju se otključava popust (kod se primenjuje tiho kroz /discount/) i prikazuju komadi u izabranoj
   kategoriji i veličini. Stanje u sessionStorage, da osvežavanje ne vraća na početak.
   Preporuka veličine: iste tabele (visina × težina) kao „Preporuka za veličinu“ na stranici proizvoda (size-guide.js). */
(() => {
  const root = document.querySelector('[data-lzbnr]');
  if (!root || root._lzbnr) return;
  root._lzbnr = true;
  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => [...el.querySelectorAll(sel)];
  const D = root.dataset;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const KEY = 'lzbnr:' + location.pathname;
  const LIMIT = parseInt(D.limit, 10) || 6;
  const pad = (n) => String(n).padStart(2, '0');
  const tpl = (str, map) => String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  /* need: top | bottom | both; cat: { top: idx, bottom: idx }; size: { top, bottom }; phase: koja grupa je na redu u koraku 2 */
  let st = { step: 0, need: null, phase: 'top', cat: {}, size: {}, gifts: [], done: false };
  try { st = Object.assign(st, JSON.parse(sessionStorage.getItem(KEY) || '{}')); } catch (e) {}
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
  const track = (event, data) => { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event }, data || {})); } catch (e) {} };
  const groups = () => (st.need === 'both' ? ['top', 'bottom'] : [st.need || 'top']);

  /* Tajmer (uvod + HUD) */
  const cd = $('[data-cd]');
  const end = cd ? Date.parse(cd.dataset.deadline) : NaN;
  const hudTime = $('[data-hud-time]');
  const setU = (u, val) => { const el = cd && cd.querySelector('[data-u="' + u + '"]'); if (el && el.textContent !== val) el.textContent = val; };
  const tick = () => {
    if (isNaN(end)) { if (hudTime) hudTime.hidden = true; return; }
    let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const d = Math.floor(s / 86400); s %= 86400;
    const h = Math.floor(s / 3600); s %= 3600;
    const m = Math.floor(s / 60); s %= 60;
    setU('d', String(d)); setU('h', pad(h)); setU('m', pad(m)); setU('s', pad(s));
    if (hudTime) hudTime.textContent = d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s);
  };
  tick(); setInterval(tick, 1000);

  /* HUD prati header sajta (header se pri skrolu sakrije, pa traka ide na vrh) */
  const hud = $('[data-hud]');
  const siteHeader = document.querySelector('.custom-header-sticky') || document.querySelector('.shopify-section-group-header-group');
  const placeHud = () => { if (hud) hud.style.top = (siteHeader ? Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom)) : 0) + 'px'; };
  let followUntil = 0;
  const follow = () => { placeHud(); if (performance.now() < followUntil) requestAnimationFrame(follow); };
  const kick = () => { const run = performance.now() >= followUntil; followUntil = performance.now() + 450; if (run) requestAnimationFrame(follow); };
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  if (siteHeader && 'MutationObserver' in window) new MutationObserver(kick).observe(siteHeader, { attributes: true, attributeFilter: ['class', 'style'] });
  placeHud();
  const syncHud = () => {
    if (!hud) return;
    hud.hidden = st.step < 1;
    st.gifts.forEach((i) => { const k = $('[data-hud-slot="' + i + '"]'); if (k) k.classList.add('is-on'); });
    const pct = $('[data-hud-slot="4"]'); if (pct) pct.classList.toggle('is-on', !!st.done);
    const lvl = $('[data-hud-lvl]');
    if (lvl) lvl.textContent = st.step >= 4 ? '✓ ' + (D.stepWord || 'Korak') + ' 3 / 3' : (D.stepWord || 'Korak') + ' ' + Math.max(1, st.step) + ' / 3';
    const fill = $('[data-hud-fill]');
    if (fill) fill.style.width = Math.min(100, (st.gifts.length / 3) * 85 + (st.done ? 15 : 0)) + '%';
  };

  /* Ekrani */
  const go = (n, opts) => {
    st.step = n; save();
    $$('[data-screen]').forEach((sc) => { const on = sc.dataset.screen === String(n); sc.hidden = !on; sc.classList.toggle('is-active', on); });
    if (n === 2) buildCats();
    if (n === 3) buildSizes();
    if (n === 4) buildFinal(opts && opts.noScroll);
    syncHud();
    if (!(opts && opts.noScroll)) {
      const top = root.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0);
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }
    track('lzbnr_step', { step: n });
  };

  /* Konfete */
  const confetti = (cv, n) => {
    if (!cv || reduce) return;
    const r = cv.getBoundingClientRect();
    const W = cv.width = Math.max(1, Math.round(r.width)), H = cv.height = Math.max(1, Math.round(r.height));
    const ctx = cv.getContext('2d');
    const cols = ['#B10F1A', '#E8363C', '#FFFFFF', '#FFD34D'];
    const ps = Array.from({ length: n || 120 }, () => ({ x: W / 2 + (Math.random() - .5) * 60, y: H * .32, vx: (Math.random() - .5) * 12, vy: -Math.random() * 12 - 3, s: 4 + Math.random() * 5, r: Math.random() * 6, vr: (Math.random() - .5) * .4, c: cols[Math.floor(Math.random() * cols.length)] }));
    const t0 = performance.now();
    const step = (t) => {
      ctx.clearRect(0, 0, W, H);
      ps.forEach((p) => { p.vy += .32; p.x += p.vx; p.y += p.vy; p.r += p.vr; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * .6); ctx.restore(); });
      if (t - t0 < 2300) requestAnimationFrame(step); else ctx.clearRect(0, 0, W, H);
    };
    requestAnimationFrame(step);
  };

  /* Prozor: otključan poklon; posle 3. poklona dugme otključava popust */
  const modal = $('[data-reveal]');
  const nextBtn = $('button[data-reveal-next]');
  const revealLeft = $('[data-reveal-left]');
  const nextLabel = nextBtn ? nextBtn.textContent : '';
  let afterReveal = null;
  const unlockGift = (i, cb) => {
    if (!st.gifts.includes(i)) { st.gifts.push(i); save(); }
    syncHud();
    track('lzbnr_gift', { gift: i });
    if (!modal) { cb && cb(); return; }
    afterReveal = cb;
    $$('[data-reveal-gift]', modal).forEach((g) => { g.hidden = g.dataset.revealGift !== String(i); });
    const left = 3 - i;
    if (revealLeft) revealLeft.textContent = left === 0 ? '' : (left === 1 ? (root.dataset.leftOne || '') : tpl(root.dataset.leftTpl || '', { n: left }));
    if (nextBtn) nextBtn.textContent = left === 0 ? (root.dataset.revealLast || nextLabel) : nextLabel;
    const k = $('.lzbnr-reveal__icon', modal);
    if (k) { k.style.animation = 'none'; void k.offsetWidth; k.style.animation = ''; }
    modal.hidden = false;
    document.body.classList.add('lzbnr-modal');
    setTimeout(() => confetti($('[data-confetti]', modal), 90), 60);
    if (nextBtn) setTimeout(() => nextBtn.focus({ preventScroll: true }), 80);
  };
  const closeReveal = () => {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('lzbnr-modal');
    const cb = afterReveal; afterReveal = null;
    if (cb) cb();
  };
  if (nextBtn) nextBtn.addEventListener('click', closeReveal);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeReveal(); });

  /* Korak 1: šta ti treba */
  $$('[data-need]').forEach((b) => b.addEventListener('click', () => {
    if (st.need !== b.dataset.need) { st.cat = {}; st.size = {}; }
    st.need = b.dataset.need; st.phase = 'top'; save();
    $$('[data-need]').forEach((x) => x.classList.toggle('is-on', x === b));
    track('lzbnr_need', { need: st.need });
    if (st.gifts.includes(1)) go(2); else unlockGift(1, () => go(2));
  }));

  /* Korak 2: kategorija (pločice grupe koja je na redu; „oboje“ = gornji pa donji deo) */
  const pools = () => $$('[data-pool]');
  const poolItems = (idx) => $$('[data-pool="' + idx + '"] [data-item]');
  const sizeCounts = (idx) => {
    const c = {};
    poolItems(idx).forEach((it) => (it.dataset.sizes || '').split('|').filter(Boolean).forEach((sz) => { c[sz] = (c[sz] || 0) + 1; }));
    return c;
  };
  function buildCats() {
    const g = st.need === 'both' ? st.phase : (st.need || 'top');
    const gl = $('[data-cat-group]'); if (gl) gl.textContent = g === 'bottom' ? (D.groupBottom || '') : (D.groupTop || '');
    $$('[data-cat]').forEach((b) => {
      b.hidden = b.dataset.group !== g;
      b.classList.toggle('is-on', st.cat[g] === b.dataset.cat);
      const n = $('[data-cat-n]', b);
      if (n) n.textContent = poolItems(b.dataset.cat).length + ' ' + (D.modelsWord || 'modela');
    });
  }
  $$('[data-cat]').forEach((b) => b.addEventListener('click', () => {
    const g = b.dataset.group;
    if (st.cat[g] !== b.dataset.cat) delete st.size[g];
    st.cat[g] = b.dataset.cat; save();
    $$('[data-cat]').forEach((x) => x.classList.toggle('is-on', x === b));
    track('lzbnr_category', { category: b.dataset.catLabel, group: g });
    if (st.need === 'both' && g === 'top') { st.phase = 'bottom'; save(); go(2); return; }
    if (st.gifts.includes(2)) go(3); else unlockGift(2, () => go(3));
  }));

  /* Korak 3: veličine iz stvarnog stanja izabrane kategorije (gornji deo S–3XL, donji deo širina W31–W38) */
  const ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
  const rank = (v) => { const i = ORDER.indexOf(String(v).toUpperCase()); if (i >= 0) return i; const n = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isNaN(n) ? 999 : 100 + n; };
  const confirmBtn = $('[data-confirm-sizes]');
  const sizesComplete = () => groups().every((g) => !!st.size[g]);
  function buildSizes() {
    const gs = groups();
    $$('[data-sizegroup]').forEach((box) => {
      const g = box.dataset.sizegroup;
      box.hidden = !gs.includes(g) || st.cat[g] === undefined;
      if (box.hidden) return;
      const wrap = $('[data-sizes="' + g + '"]', box);
      const counts = sizeCounts(st.cat[g]);
      const sizes = Object.keys(counts).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
      wrap.classList.toggle('lzbnr-sizes--wide', sizes.length > 4);
      wrap.innerHTML = '';
      sizes.forEach((sz) => {
        const b = document.createElement('button');
        b.type = 'button';
        const low = counts[sz] <= 3;
        b.className = 'lzbnr-size' + (low ? ' is-low' : '') + (st.size[g] === sz ? ' is-on' : '');
        b.dataset.size = sz; b.dataset.group = g;
        b.innerHTML = '<b></b><i></i>';
        b.querySelector('b').textContent = sz;
        b.querySelector('i').textContent = (low ? (D.leftWord || 'još') + ' ' : '') + counts[sz] + ' ' + (D.modelsWord || 'modela');
        b.addEventListener('click', () => pickSize(g, sz));
        wrap.appendChild(b);
      });
    });
    if (confirmBtn) { confirmBtn.hidden = gs.length < 2; confirmBtn.disabled = !sizesComplete(); }
  }
  function pickSize(g, sz) {
    st.size[g] = sz; save();
    $$('[data-sizes="' + g + '"] .lzbnr-size').forEach((x) => x.classList.toggle('is-on', x.dataset.size === sz));
    track('lzbnr_size', { group: g, size: sz });
    if (groups().length < 2) finishSizes(); else if (confirmBtn) confirmBtn.disabled = !sizesComplete();
  }
  function finishSizes() {
    if (!sizesComplete()) return;
    if (st.gifts.includes(3)) go(4); else unlockGift(3, () => go(4));
  }
  if (confirmBtn) confirmBtn.addEventListener('click', finishSizes);

  /* Preporuka po visini i težini (tabele sa sajta); 2XL u tabeli = XXL na proizvodima */
  const SM = {"h":[157.0,160.0,170.0,177.0,183.0,190.0,197.0,205.0,210.0,215.0,999.0],"w":[60.0,65.0,73.0,80.0,87.0,95.0,105.0,112.0,120.0,999.0],"m":[[null,null,null,null,null,null,null,null,null,null],[null,["S","","L29 W31",""],["S","","L29 W31",""],["S","","L29 W31","L29 W32"],["S","","L29 W31","L29 W32"],null,null,null,null,null],[null,["S","","L29 W31",""],["S","","L29 W31",""],["S","","L29 W31","L29 W32"],["S","M","L29 W32","L29 W33"],["M","","L29 W34",""],["L","XL","L29 W36",""],["XL","2XL","L29 W38",""],null,null],[null,["S","","L29 W31",""],["S","M","L29 W32","L29 W33"],["S","M","L29 W32","L29 W33"],["M","","L29 W32","L29 W33"],["L","","L29 W33","L29 W34"],["XL","","L29 W36",""],["XL","2XL","L29 W38",""],null,null],[null,["S","","L29 W31",""],["S","M","L29 W31","L29 W32"],["S","M","L29 W32",""],["M","","L29 W32","L29 W33"],["L","","L29 W33","L29 W34"],["XL","","L29 W36",""],["2XL","3XL","L29 W36","L29 W38"],["3XL","","L29 W38",""],null],[null,null,["M","","L31 W31",""],["M","","L31 W32",""],["L","","L31 W32","L31 W33"],["L","","L31 W34",""],["XL","","L31 W36",""],["2XL","","L31 W36","L31 W38"],["3XL","","L31 W38",""],null],[null,null,["L","","L31 W31","L33 W31"],["L","","L31 W32","L33 W32"],["L","","L31 W32","L33 W33"],["L","","L31 W34","L33 W34"],["XL","","L31 W36","L33 W36"],["2XL","3XL","L31 W36","L33 W38"],["3XL","","L31 W38",""],null],[null,null,null,["L","","L33 W31","L33 W32"],["L","","L33 W32","L33 W33"],["L","","L33 W33","L33 W34"],["XL","2XL","L33 W36",""],["2XL","3XL","L33 W36","L33 W38"],["3XL","","L33 W38",""],null],[null,null,null,null,["XL","","L33 W31","L33 W32"],["XL","","L33 W33","L33 W34"],["2XL","","L33 W36",""],["2XL","3XL","L33 W36","L33 W38"],["3XL","","L33 W38",""],null],[null,null,null,null,null,["XL","","L33 W33","L33 W34"],["XL","","L33 W33","L33 W34"],["2XL","","L33 W36",""],["3XL","","L33 W38",""],null],[null,null,null,null,null,null,null,null,null,null]]};
  const bucket = (arr, v) => { for (let i = 0; i < arr.length; i++) if (v <= arr[i]) return i; return -1; };
  const norm = (v) => String(v || '').replace(/^2XL$/i, 'XXL');
  const recOut = $('[data-rec-out]');
  const useBtn = (g, sz) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'lzbnr-rec__use'; b.textContent = tpl(D.recUse || 'Uzmi {size}', { size: sz });
    b.addEventListener('click', () => { pickSize(g, sz); const box = $('[data-sizegroup="' + g + '"]'); if (box && !box.hidden) box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); });
    return b;
  };
  const recLine = (label, main, loose, g) => {
    const line = document.createElement('div'); line.className = 'lzbnr-rec__line';
    const t = document.createElement('span'); t.innerHTML = tpl(label, { size: '<b></b>' }); t.querySelector('b').textContent = main;
    if (loose) { const sm = document.createElement('small'); sm.textContent = ' · ' + tpl(D.recLoose || '{size}', { size: loose }); t.appendChild(sm); }
    line.appendChild(t);
    const available = groups().includes(g) && st.cat[g] !== undefined && $('[data-sizes="' + g + '"] [data-size="' + main + '"]');
    if (available) line.appendChild(useBtn(g, main));
    return line;
  };
  const recGo = $('[data-rec-go]');
  if (recGo) recGo.addEventListener('click', () => {
    const h = parseFloat(($('[data-rec-h]') || {}).value), w = parseFloat(($('[data-rec-w]') || {}).value);
    if (!recOut) return;
    recOut.innerHTML = ''; recOut.hidden = false;
    const hi = isNaN(h) ? -1 : bucket(SM.h, h), wi = isNaN(w) ? -1 : bucket(SM.w, w);
    const cell = hi >= 0 && wi >= 0 ? (SM.m[hi] || [])[wi] : null;
    if (!cell) { recOut.textContent = D.recNone || ''; return; }
    const shirt = norm(cell[0]), shirtLoose = norm(cell[1]);
    const pw = (cell[2].match(/W\d+/) || [''])[0], pwLoose = (cell[3].match(/W\d+/) || [''])[0];
    if (shirt) recOut.appendChild(recLine(D.recTop || '{size}', shirt, shirtLoose && shirtLoose !== shirt ? shirtLoose : '', 'top'));
    if (pw) recOut.appendChild(recLine(D.recBottom || '{size}', pw, pwLoose && pwLoose !== pw ? pwLoose : '', 'bottom'));
    $$('.lzbnr-size').forEach((b) => b.classList.toggle('is-rec', (b.dataset.group === 'top' && b.dataset.size === shirt) || (b.dataset.group === 'bottom' && b.dataset.size === pw)));
    track('lzbnr_rec', { h, w, shirt, pants: pw });
  });

  /* Finale: popust + pokloni + komadi u izabranoj kategoriji i veličini */
  const parseVars = (s) => { const m = {}; String(s || '').split('|').forEach((pair) => { const i = pair.indexOf(':'); if (i > 0) m[pair.slice(0, i)] = pair.slice(i + 1); }); return m; };
  const withFilter = (url, param, sz) => (!url ? '#' : (!sz || !param ? url : url + (url.indexOf('?') === -1 ? '?' : '&') + 'filter.v.availability=1&' + encodeURIComponent(param) + '=' + encodeURIComponent(sz)));
  const CART_SVG = '<svg width="18" height="18" viewBox="0 0 21 21" fill="none" aria-hidden="true" focusable="false"><path d="M1.5 2.5h2.2l2.5 9.4h9.1l2.2-6.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.2 3.2v4.6M8.9 5.5h4.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="7.6" cy="16.3" r="1.5" fill="currentColor"/><circle cx="14.2" cy="16.3" r="1.5" fill="currentColor"/></svg>';
  const setAddLabel = (btn, sz) => { btn.innerHTML = CART_SVG; btn.appendChild(document.createTextNode(tpl(D.addTpl, { size: sz }))); };
  function renderPool(p) {
    const g = p.dataset.group, sz = st.size[g] || '';
    const items = $$('[data-item]', p);
    const list = items.filter((it) => sz && (it.dataset.sizes || '').includes('|' + sz + '|'));
    const expanded = p.dataset.expanded === '1';
    const show = expanded ? list : list.slice(0, LIMIT);
    const grid = $('[data-grid]', p);
    if (grid) list.forEach((it) => grid.appendChild(it));
    const quick = D.quickAdd !== '0';
    items.forEach((it, i) => {
      it.hidden = !show.includes(it);
      if (!it.hidden) it.style.animationDelay = Math.min(show.indexOf(it), 8) * 40 + 'ms';
      const btn = $('[data-add]', it), buy = $('.lz-card__buy, .lazare-product-card__actions', it);
      const vid = quick && sz ? parseVars(it.dataset.variants)[sz] : '';
      if (btn) { btn.hidden = !vid; if (vid && btn.dataset.id !== vid) { btn.dataset.id = vid; btn.dataset.size = sz; btn.disabled = false; btn.classList.remove('is-added', 'is-busy'); setAddLabel(btn, sz); } }
      if (buy) buy.hidden = !!vid;
    });
    const t = $('[data-pool-title]', p); if (t) t.textContent = tpl(t.dataset.tpl, { cat: p.dataset.label, size: sz });
    /* Marko 03.11.2026: promena veličine ispod naslova, bez vraćanja kroz korake */
    if (t && D.sizeSwitch) {
      let sw = $('[data-szsw]', p);
      if (!sw) { sw = document.createElement('div'); sw.className = 'lzbnr-szsw'; sw.setAttribute('data-szsw', ''); t.insertAdjacentElement('afterend', sw); }
      const all = new Set(); items.forEach((it) => (it.dataset.sizes || '').split('|').filter(Boolean).forEach((x) => all.add(x)));
      sw.innerHTML = '';
      const lab = document.createElement('p'); lab.className = 'lzbnr-szsw__label'; lab.textContent = D.sizeSwitch; sw.appendChild(lab);
      const row = document.createElement('div'); row.className = 'lzbnr-szsw__row'; sw.appendChild(row);
      [...all].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b)).forEach((x) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'lzbnr-szsw__btn' + (x === sz ? ' is-on' : ''); b.textContent = x; b.setAttribute('aria-pressed', x === sz ? 'true' : 'false');
        b.addEventListener('click', () => { if (st.size[g] === x) return; st.size[g] = x; save(); track('lzbnr_size_change', { size: x, group: g }); buildFinal(true); });
        row.appendChild(b);
      });
    }
    const empty = $('[data-empty]', p); if (empty) { empty.hidden = list.length > 0; empty.textContent = tpl(D.emptyTpl, { cat: p.dataset.label, size: sz }); }
    const more = $('[data-more]', p); if (more) { more.hidden = expanded || list.length <= LIMIT; more.textContent = tpl(D.moreTpl, { n: list.length - LIMIT }); }
    const all = $('[data-all]', p); if (all) { all.href = withFilter(p.dataset.url, p.dataset.param, sz); all.textContent = tpl(D.allTpl, { cat: p.dataset.label, size: sz }); }
  }
  function buildFinal(restore) {
    const chosen = groups().map((g) => String(st.cat[g]));
    pools().forEach((p) => { p.hidden = !chosen.includes(p.dataset.pool); if (!p.hidden) renderPool(p); });
    /* Ostale kategorije ispod komada: sakrij već prikazane, link sa filterom izabrane veličine */
    $$('[data-more-cat]').forEach((a) => { a.hidden = chosen.includes(a.dataset.moreCat); a.href = withFilter(a.dataset.url, a.dataset.param, st.size[a.dataset.group] || ''); });
    if (!st.done) {
      st.done = true; save(); syncHud();
      confetti($('[data-confetti-page]'), 180);
      markCart();
      track('lzbnr_unlocked', { need: st.need, size: st.size });
    }
  }
  $$('[data-more]').forEach((b) => b.addEventListener('click', () => { const p = b.closest('[data-pool]'); if (p) { p.dataset.expanded = '1'; renderPool(p); } }));

  /* Kod popusta i atribut korpe: tiho, jednom */
  let codeDone = false;
  async function markCart() {
    try {
      if (D.attrName) await fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { [D.attrName]: D.attrValue } }) });
      if (D.code && !codeDone) { codeDone = true; await fetch('/discount/' + encodeURIComponent(D.code) + '?redirect=%2F', { credentials: 'same-origin' }); }
    } catch (e) {}
  }
  $$('[data-copy]').forEach((c) => c.addEventListener('click', () => {
    const code = c.dataset.code || '';
    const done = () => { c.classList.add('is-copied'); const l = $('[data-copy-label]', c); if (l) { l.dataset.orig = l.dataset.orig || l.textContent; l.textContent = c.dataset.copied || l.dataset.orig; setTimeout(() => { l.textContent = l.dataset.orig; c.classList.remove('is-copied'); }, 2200); } track('lzbnr_copy', {}); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done); else done();
  }));

  /* Dodavanje u korpu: tačna varijanta u izabranoj veličini, fioka korpe se osvežava kao posle klasične forme */
  let keepY = null;
  new MutationObserver(() => {
    if (keepY === null) return;
    if (!document.body.classList.contains('overflow-hidden')) { const y = keepY; keepY = null; window.scrollTo({ top: y, behavior: 'instant' }); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  function syncHeader(cart) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !cart) return;
    let count = bubble.querySelector('.custom-header__cart-count');
    if (!count && cart.item_count > 0) { count = document.createElement('span'); count.className = 'custom-header__cart-count'; count.setAttribute('aria-hidden', 'true'); bubble.appendChild(count); }
    if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
  }
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();
    const id = parseInt(btn.dataset.id, 10);
    if (!id || btn.disabled) return;
    btn.disabled = true; btn.classList.add('is-busy');
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then((res) => {
        btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.textContent = D.addedText || 'Dodato';
        track('lzbnr_add_to_cart', { id, size: btn.dataset.size || '' });
        if (drawer && res.sections && typeof drawer.renderContents === 'function') { keepY = window.scrollY; if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn); drawer.renderContents(res); }
        else { fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()).then(syncHeader).catch(() => {}); document.dispatchEvent(new CustomEvent('cart:refresh')); }
        setTimeout(() => { btn.disabled = false; btn.classList.remove('is-added'); setAddLabel(btn, btn.dataset.size || ''); }, 2600);
      })
      .catch(() => { btn.disabled = false; btn.classList.remove('is-busy'); });
  });

  /* Navigacija */
  $$('[data-next]').forEach((b) => b.addEventListener('click', () => go(parseInt(b.dataset.next, 10))));
  $$('[data-back]').forEach((b) => b.addEventListener('click', () => { const n = parseInt(b.dataset.back, 10); if (n === 1) st.phase = 'top'; if (n === 2 && st.need === 'both') st.phase = 'bottom'; save(); go(n); }));

  /* Povratak posle osvežavanja */
  if (st.need) { const o = $('[data-need="' + st.need + '"]'); if (o) o.classList.add('is-on'); }
  const valid = st.step <= 1 || (st.step === 2 && st.need) || (st.step === 3 && st.need && groups().every((g) => st.cat[g] !== undefined)) || (st.step === 4 && st.need && sizesComplete());
  if (st.step > 0 && valid) go(st.step, { noScroll: true }); else { st.step = 0; syncHud(); }
})();
